import A11yHiddenBox from '@rover/kibble/styles/A11yHiddenBox';

import MicrodataHTMLAttributes from './MicrodataHTMLAttributes';
import schema from './schema';

type GeoCoordinatesProps = {
  latitude: string;
  longitude: string;
} & MicrodataHTMLAttributes;

const GeoCoordinates: React.FC<GeoCoordinatesProps> = ({
  latitude,
  longitude,
  ...props
}: GeoCoordinatesProps) => (
  <A11yHiddenBox {...props} webProps={{ itemScope: true, itemType: schema`GeoCoordinates` }}>
    <meta itemProp="latitude" content={latitude} />
    <meta itemProp="longitude" content={longitude} />
  </A11yHiddenBox>
);

export default GeoCoordinates;
